
interface ActivitiesHeaderProps {}

export const ActivitiesHeader = ({}: ActivitiesHeaderProps) => {
  return (
    <section className="w-full bg-gradient-to-r from-golden-orange to-brand-purple text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold mb-8">
            Kids' Corner Activities
          </h1>
          <p className="text-xl lg:text-2xl max-w-4xl mx-auto opacity-90 leading-relaxed">
            Fun, educational activities inspired by Bobo & Teedee® adventures! Perfect for home, school, or anywhere learning happens.
          </p>
        </div>
      </div>
    </section>
  );
};
